import * as React from 'react'
// Hooks
import { PAYMENT_TYPE } from '../payment.hooks'
// Components
import Subscription from './components/subscription'
import Video from './components/video'

const PaymentSidebar = ({ type, pending, disabled }) => {
  const rootCln = 'buying-side'

  return (
    <aside className={rootCln}>
      <div className={`${rootCln}-inner`}>
        <div className={`${rootCln}-scroll`}>
          <div className={`${rootCln}-scrollable`}>
            {type === PAYMENT_TYPE.VIDEO ? (
              <Video pending={pending} disabled={disabled} />
            ) : (
              <Subscription pending={pending} disabled={disabled} />
            )}
          </div>
        </div>
      </div>
    </aside>
  )
}

export default PaymentSidebar
